"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

/**
 * Репорт ошибки из route/global error boundary в GlitchTip (KAN-312).
 * Ожидаемые recovery-кейсы (NEXT_REDIRECT, ChunkLoadError) не шлём — это не краши.
 */
export function isExpectedBoundaryError(error: Error): boolean {
  return (
    error.message?.includes("NEXT_REDIRECT") ||
    error.message?.includes("NEXT_NOT_FOUND") ||
    error.name === "ChunkLoadError" ||
    error.message?.includes("Failed to fetch dynamically imported module")
  );
}

export function useReportBoundaryError(
  error: Error & { digest?: string },
  boundary: string,
): void {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      console.error(`[${boundary}]`, error);
    }
    if (isExpectedBoundaryError(error)) return;
    Sentry.captureException(error, {
      extra: {
        digest: error.digest,
        route: typeof window !== "undefined" ? window.location.pathname : undefined,
      },
      tags: {
        boundary,
        stage: "react_error",
      },
    });
  }, [error, boundary]);
}
